module.exports = __webpack_public_path__ + "img/title_1.edd6e1cd.png";